import "./MobilePage.css";
import logo from 'asset/logo/logo_original.svg';

const MobilePage = () => {
    return (
        <div className={"mobile-page"}>
            <div className={"mobile-logo-wrap"}>
                <img className={"mobile-logo"} src={logo} alt={"perplay"} onClick={()=>{
                    window.location.href='https://perplay.io';
                }}/>
            </div>
            <h1 className={"mobile-guide-text"}>
                PERPLAY GENESIS NFT IS WAITING FOR YOU ON PC BROWSER.
            </h1>
            <p className={"mobile-copyright"}>
                Copyright@Blockbusterlab Inc. All rights reserved.
            </p>
        </div>
    )
}
export default MobilePage;